import { render, staticRenderFns } from "./ISPTicketSummary.vue?vue&type=template&id=39bcd635&"
import script from "./ISPTicketSummary.vue?vue&type=script&lang=js&"
export * from "./ISPTicketSummary.vue?vue&type=script&lang=js&"
import style0 from "./ISPTicketSummary.vue?vue&type=style&index=0&id=39bcd635&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports